@if (readNext) {
    <div
        [ngClass]="additionalClasses"
        class="mb-5 h-full rounded-lg bg-white px-4 md:flex md:items-center md:px-0">
        <div class="block md:hidden">
            <a
                [routerLink]="['/knowledge', readNext.urlSlug]"
                class="mb-4 flex items-center space-x-2">
                <span class="font-heading text-lg text-darkgrey">
                    Read next
                </span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    class="h-3 w-3">
                    <path
                        fill="#000000"
                        d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                </svg>
            </a>
        </div>
        <div
            class="relative mr-4 w-full overflow-hidden rounded-lg md:h-[230px] md:w-[230px]">
            <app-lazy-asset
                [configuration]="featuredImageConfiguration"
                class="h-66"></app-lazy-asset>
        </div>
        <div class="mt-5 flex-1 md:mt-0">
            <a
                [routerLink]="['/knowledge', readNext.urlSlug]"
                class="mb-4 flex hidden items-center space-x-2 md:flex">
                <span class="font-heading text-lg text-darkgrey">
                    Read next
                </span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    class="h-3 w-3">
                    <path
                        fill="#000000"
                        d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                </svg>
            </a>
            <h3 class="mt-0 font-heading text-2xl font-semibold">
                {{ readNext.shortTitle }}
            </h3>
            <p class="font-serif text-base">{{ readNext.description }}</p>
        </div>
    </div>
}

@if (!article) {
    <div>
        <p>Loading...</p>
    </div>
}
